import { useLazyQuery } from "@apollo/client/react";
import React, { useState, useEffect } from 'react';
import { Checkbox, FormControl, FormControlLabel, Grid, CircularProgress } from '@mui/material';
import { GET_PERMISO_BLOQUEO } from '../../../../data/graphQL/queries/RequisitoClientes/getPermisoBloqueoClienteRequisito';

export const StepBloqueos = ({ fullFormData, handleChangeFullFormData, allowedWrite }) => {
  const [hasPermission, setHasPermission] = useState(false);
  const [bloqueos] = useState([
    { id: 'bloqueoPaciente', descripcion: 'Bloqueo de inicio paciente' },
    { id: 'bloqueoProrroga', descripcion: 'Bloqueo de prorrogas' },
    { id: 'bloqueoCotizar', descripcion: 'Bloqueo cotizador' },
    { id: 'bloqueoEnvio', descripcion: 'Bloqueo de envios' }]
  );

  const handleCheck = (e) => {
    const { id, checked } = e.target;
    handleChangeFullFormData(id, checked);
  };

  useEffect(() => {
    getBloqueoPermiso();
  }, []);

  const [getBloqueoPermiso, { loading: bloqueoPermisoLoading, data: permisoData }] = useLazyQuery(GET_PERMISO_BLOQUEO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!permisoData) return;

    setHasPermission(permisoData.permisoBloqueoClienteRequisito);
  }, [permisoData]);

  return (
    <FormControl fullWidth component="fieldset">
      <Grid container justifyContent="space-between">
        {!bloqueoPermisoLoading && bloqueos.map((bloqueo) =>
          <Grid key={bloqueo.id} size="grow">
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!fullFormData[bloqueo.id]}
                  size="small"
                  id={bloqueo.id}
                  onChange={handleCheck}
                  disabled={!allowedWrite || !hasPermission} />

              }
              labelPlacement='start'
              label={bloqueo.descripcion} />

          </Grid>
        )}
      </Grid>
      {bloqueoPermisoLoading && <div className='tab-loading-section'>
        <CircularProgress />
      </div>}
    </FormControl>);

};